import { IServico } from "../../../interfaces/listItems";

export function Item({ cod_servico, descricao, link_servico, titulo, url }: IServico) {
    return (
        <li><a href={`https://api-portal.itajai.sc.gov.br/portaladm-pmitajai/servico/acesso/cod/${cod_servico}`} style={{ color: "#000", textDecoration: 'none', marginTop: 20 }}>{titulo}</a></li>
    )
} 